'use client';

import Link from 'next/link';

import { Button } from '@holistic/components';
import {
  ArrowLeft,
  ArrowRight,
  MessageCircle,
} from '@holistic/components/icons';

type StepActionsProps = {
  /** İlk adımda yardım bloğu, sonrakilerde "Geri dön" gösterilir. */
  onBack?: () => void;
  /** Verilmezse buton çıkmaz; tek seçimli adımlar seçimde kendiliğinden ilerler. */
  onContinue?: () => void;
  continueLabel?: string;
  disabled?: boolean;
};

/** Adım kartının alt aksiyon satırı. */
const StepActions = ({
  onBack,
  onContinue,
  continueLabel = 'Devam et',
  disabled = false,
}: StepActionsProps) => (
  <div className="flex flex-col gap-4 border-t border-gray-100 pt-5 md:flex-row md:items-center md:justify-between">
    {onBack ? (
      <button
        type="button"
        onClick={onBack}
        className="hover:text-primary flex w-fit cursor-pointer items-center gap-2 text-sm font-medium text-gray-500 transition-colors"
      >
        <ArrowLeft className="size-4" />
        Geri dön
      </button>
    ) : (
      <div className="flex items-start gap-3">
        <span className="bg-primary/10 flex size-9 shrink-0 items-center justify-center rounded-lg">
          <MessageCircle className="text-primary size-4" />
        </span>
        <div className="leading-relaxed">
          <p className="text-sm font-semibold text-gray-900">
            Yardıma mı ihtiyacınız var?
          </p>
          <p className="text-xs text-gray-500">
            Hangi cihazı seçeceğinizden emin değil misiniz?{' '}
            <Link
              href="/iletisim"
              className="text-primary font-medium whitespace-nowrap hover:underline"
            >
              İletişime geçin
            </Link>
          </p>
        </div>
      </div>
    )}

    {onContinue && (
      <Button
        type="button"
        size="lg"
        disabled={disabled}
        onClick={onContinue}
        className="w-full rounded-full px-8 font-semibold md:w-fit"
      >
        {continueLabel}
        <ArrowRight />
      </Button>
    )}
  </div>
);

export default StepActions;
